import { z } from "zod";

export const validationSchema = z.object({
  description: z.string().optional(),
  legal_number: z.string().optional(),
  name: z.string().nonempty(),
  phone: z.string().optional(),
});
